import { RootState } from 'duck/store'
import { connect } from 'react-redux'

import { getAllOrganizationsIds } from 'scenes/Dashboard/data/organizations/selectors'

import { updateCurrentPage } from '../../duck/actions'
import { getSearchParams } from '../../duck/selectors'
import OrganizationsTable, { OrganizationsTableProps } from './presentational'

const mapStateToProps = (state: RootState): StateProps => {
  const organizationsIds = getAllOrganizationsIds(state)
  const { currentPage, limit, search } = getSearchParams(state)
  return {
    currentPage,
    limit,
    search,
    organizationsIds,
  }
}

type StateProps = Omit<OrganizationsTableProps, 'onChangePage'>

const mapDispatchToProps = {
  onChangePage: updateCurrentPage,
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationsTable)
